export const EVENT_ID_CHANGED = 'EVENT_ID_CHANGED';
export const EVENT_STATE_CHANGED = 'EVENT_STATE_CHANGED';
export const EVENT_DATE_CHANGED = 'EVENT_DATE_CHANGED';
export const SURFER_STATE_CHANGED = 'SURFER_STATE_CHANGED';
export const TH_TC_CHANGED = 'TH_TC_CHANGED';
export const EVENT_DATA_CHANGED = 'EVENT_DATA_CHANGED';
export const EVENTS_SET = 'EVENTS_SET';
export const EVENT_ADDED = 'EVENT_ADDED';
export const EVENT_EDITED = 'EVENT_EDITED';
export const EVENT_DELETED = 'EVENT_DELETED';
export const HYMOTSE_LOGIN = 'HYMOTSE_LOGIN';
export const HLA_CONTENT_CHANGED = 'HLA_CONTENT_CHANGED';
export const EVENT_TIME_PREFERENCE_CHANGED = 'EVENT_TIME_PREFERENCE_CHANGED';
export const EVENT_UNIX_TIME_CHANGED = 'EVENT_UNIX_TIME_CHANGED';
